import { defineStore } from "pinia";
import { useStorage } from "@vueuse/core";

export const useGlobalCrews = defineStore("globalCrews", {
  state: () => ({
    dragging: false,
    crewData: {},
    selectedCrewIds: [], // Para selección múltiple
    layout: [],
    dropLayout: null,
    dropLayoutChildren: null,
    crewsDays: {},
    filteredCrewsDays: {},
    colorCrewMap: {},
    filters: {
      name: "",
      day: "",
      description: "",
      technicians: "",
      type: [],
      subcontractor: [],
    },
    crewsListado: [],
    currentPage: 1,
    currentItemsPerPage: 25,
  }),
  actions: {
    setIsDragging(value) {
      this.dragging = value;
    },
    setCrewData(value) {
      this.crewData = value;
    },
    clearCrewData() {
      this.crewData = {};
    },
    clearSelectedCrewIds() {
      this.selectedCrewIds = [];
    },
    setSelectedCrewId(crewId, selected) {
      if (!crewId) return;
      const idx = this.selectedCrewIds.indexOf(crewId);
      if (selected) {
        if (idx === -1) this.selectedCrewIds.push(crewId);
      } else {
        if (idx !== -1) this.selectedCrewIds.splice(idx, 1);
      }
    },
    toggleSelectedCrewId(crewId) {
      if (!crewId) return;
      const idx = this.selectedCrewIds.indexOf(crewId);
      if (idx === -1) this.selectedCrewIds.push(crewId);
      else this.selectedCrewIds.splice(idx, 1);
    },
    pushCrewLayout(value) {
      this.layout.push(value);
    },
    clearLayout() {
      this.layout = [];
    },
    setDropLayout(value) {
      this.dropLayout = value;
    },
    setDropLayoutChildren(value) {
      this.dropLayoutChildren = value;
    },
    setCrewsDays(value) {
      this.crewsDays = value;
      this.filteredCrewsDays = value;
    },
    setFilteredCrewsDays(crews) {
      if (!crews || !crews.length) {
        this.filteredCrewsDays = this.crewsDays;
        return;
      }
      const crewIds = crews.map((crew) => crew.AMCREWID);
      this.filteredCrewsDays = Object.fromEntries(
        Object.entries(this.crewsDays).filter(([key, value]) =>
          crewIds.includes(key)
        )
      );
    },
    setCurrentPage(page) {
      this.currentPage = page;
    },
    setCurrentItemsPerPage(itemsPerPage) {
      this.currentItemsPerPage = itemsPerPage;
    },
    async initFilters() {
      // Sincronizar los filtros con el almacenamiento local
      const storedFilters = useStorage("globalCrews:filters", this.filters);

      // Observar cambios en `filters` y actualizar `localStorage`
      watch(
        () => this.filters,
        (newFilters) => {
          storedFilters.value = newFilters;
        },
        { deep: true } // Necesario para detectar cambios en propiedades anidadas
      );

      if (storedFilters.value) {
        this.filters = storedFilters.value;
      }
      /* if(storedFilters.value) {
        this.filters = storedFilters.value;
      } */
    },
  },
  getters: {
    selectedCrewIdsSet: (state) => new Set(state.selectedCrewIds || []),
  },
});
